import { UserNavbar } from "@hl/shared-features/lib/features/auth/UserNavbar";
import { ModalStack } from "@hl/shared-features/lib/features/modal";

export const EmbedConnectWallet = () => {
  return (
    <ModalStack>
      <UserNavbar hideThemeSelection hideAvatar />
    </ModalStack>
  );
};
